var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProcoreConfirmAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#F7F9FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28 17.9995C22.4772 17.9995 18 22.4767 18 27.9995C18 33.5224 22.4772 37.9995 28 37.9995C33.5228 37.9995 38 33.5224 38 27.9995C38 22.4767 33.5228 17.9995 28 17.9995ZM16 27.9995C16 21.3721 21.3726 15.9995 28 15.9995C34.6274 15.9995 40 21.3721 40 27.9995C40 34.6269 34.6274 39.9995 28 39.9995C21.3726 39.9995 16 34.6269 16 27.9995ZM28 21.9995C28.5523 21.9995 29 22.4472 29 22.9995V27.9995C29 28.5518 28.5523 28.9995 28 28.9995C27.4477 28.9995 27 28.5518 27 27.9995V22.9995C27 22.4472 27.4477 21.9995 28 21.9995ZM28 30.9995C28.5523 30.9995 29 31.4472 29 31.9995V32.4995C29 33.0518 28.5523 33.4995 28 33.4995C27.4477 33.4995 27 33.0518 27 32.4995V31.9995C27 31.4472 27.4477 30.9995 28 30.9995Z",
    fill: "#CA2867"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProcoreConfirmAlert);
export default __webpack_public_path__ + "static/media/procore-confirm-alert.b82f5365efec560f7978b0d2dde3fdd8.svg";
export { ForwardRef as ReactComponent };